import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getPublishedAppVersionKey = (): UseDataQuery['queryKey'] => ['app-version'];
